import startCase from 'lodash/startCase'

export default {
  methods: {
    getComponentName (section) {
      let componentName = section?.__typename || section?.__component
      componentName = ('Builder' + startCase(componentName)).replace(/Component/, '')
        .replace(/\s+/g, '')
      // Removing duplicates e.g. BuilderContentContent becomes BuilderContent. Requires for component autoloading
      const componentNameParts = [...new Set(componentName.split(/(?=[A-Z])/))]
      return startCase(componentNameParts.join('')).replace(/\s+/g, '')
    },
    getComponentKey (section, index) {
      return section.id + '-' + index + '-' + (section?.__typename || section?.__component)
    }
  }
}
